(() => {
  const sizeNames = ['size', 'größe', 'groesse', 'maat'];
  const textOrder = ['xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];

  const rank = (value) => {
    const normalized = value.trim().toLowerCase().replace(',', '.');
    const numeric = Number.parseFloat(normalized);

    if (Number.isFinite(numeric) && /^\d+(\.\d+)?$/.test(normalized)) {
      return [0, numeric];
    }

    const textIndex = textOrder.indexOf(normalized);
    return textIndex === -1 ? [2, normalized] : [1, textIndex];
  };

  const sortFieldset = (fieldset) => {
    if (fieldset.dataset.sizeSorted === 'true') return;

    const legend = fieldset.querySelector('legend')?.textContent.trim().toLowerCase() || '';
    if (!sizeNames.some((name) => legend.includes(name))) return;

    const pairs = [...fieldset.querySelectorAll(':scope > input[type="radio"]')]
      .map((input) => ({ input, label: fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`) }))
      .filter((pair) => pair.label);

    pairs.sort((a, b) => {
      const aRank = rank(a.input.value);
      const bRank = rank(b.input.value);
      return aRank[0] === bRank[0]
        ? String(aRank[1]).localeCompare(String(bRank[1]), undefined, { numeric: true })
        : aRank[0] - bRank[0];
    });

    pairs.forEach(({ input, label }) => {
      fieldset.append(input, label);
    });
    fieldset.dataset.sizeSorted = 'true';
  };

  const sortSizes = (root = document) => {
    if (root.matches?.('.product-form__input--pill')) sortFieldset(root);
    root.querySelectorAll('.product-form__input--pill').forEach(sortFieldset);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sortSizes(), { once: true });
  } else {
    sortSizes();
  }

  document.addEventListener('shopify:section:load', (event) => sortSizes(event.target));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) sortSizes(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
